import React, {useState} from 'react';

import {POPULAR_TOPICS_CONFIG} from './config';
import * as S from './FCRightNav.styles';
import {type RightNavTopic} from './types';

export interface FCRightNavProps {
  mobile?: boolean;
  activeTag: string;
}

export const FCRightNav: React.FC<FCRightNavProps> = React.memo(
  ({mobile, activeTag}) => {
    if (mobile) {
      return (
        <>
          {POPULAR_TOPICS_CONFIG.map(topic => (
            <MobileTopicGroup
              key={topic.name}
              topic={topic}
              activeTag={activeTag}
            />
          ))}
        </>
      );
    }

    return (
      <>
        <S.SectionHeader>Popular Topics</S.SectionHeader>
        {POPULAR_TOPICS_CONFIG.map(topic => (
          <S.Section key={topic.name} smallMargin>
            <S.TopicListHeader>{topic.name}</S.TopicListHeader>
            {topic.items.map((item, index) => (
              <S.TopicListItem
                key={index}
                to={item.link}
                active={activeTag === item.name}>
                {item.name}
              </S.TopicListItem>
            ))}
          </S.Section>
        ))}
      </>
    );
  }
);

FCRightNav.displayName = 'FCRightNav';

const MobileTopicGroup: React.FC<{
  topic: RightNavTopic;
  activeTag: string;
}> = React.memo(({topic, activeTag}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <S.MobileNavDropdownTrigger onClick={() => setIsOpen(!isOpen)}>
        {topic.name}
        <S.MobileNavDropdownTriggerIcon
          name={isOpen ? 'chevron-up' : 'chevron-down'}
        />
      </S.MobileNavDropdownTrigger>
      {isOpen && (
        <>
          {topic.items.map((item, index) => (
            <S.MobileNavDropdownLink key={index} to={item.link}>
              {item.name}
            </S.MobileNavDropdownLink>
          ))}
        </>
      )}
    </>
  );
});

MobileTopicGroup.displayName = 'MobileTopicGroup';
